/**
|--------------------------------------------------
| @vunv

|--------------------------------------------------
*/

import { is_empty } from "./validate"

// use: get_unique(arr, 'id')
const list_unit = [{
	"text": "Kg",
	"value": 1
}, {
	"text": "Lít",
	"value": 2
}, {
	"text": "Cái",
	"value": 3
}, {
	"text": "Thùng",
	"value": 4
}, {
	"text": "Chai",
	"value": 5
}, {
	"text": "Bộ",
	"value": 6
}, {
	"text": "Can",
	"value": 7
}, {
	"text": "Công",
	"value": 8
}, {
	"text": "DVT",
	"value": 9
}, {
	"text": "ml",
	"value": 10
}]

const LIST_UNIT = {
	1: "Kg",
	2: "Lít",
	3: "Cái",
	4: "Thùng",
	5: "Chai",
	6: "Bộ",
	7: "Can",
	8: "Công",
	9: "DVT",
	10: "ml",
}

const render_unit = (unit) => {
	const found = list_unit?.filter(item => item.value === unit)
	if (is_empty(found[0])) {
		return "Cái"
	}
	return found.map(item => item.text)
}

const list_plans = [
	{
		text: "Gói dùng thử",
		value: 1
	},
	{
		text: "Gói tiết kiệm",
		value: 2
	},
	{
		text: "Gói tiêu chuẩn",
		value: 3
	},
	{
		text: "Gói nâng cao",
		value: 4
	},
]

const TEXT_PLAN = {
	1: "Gói dùng thử",
	2: "Gói tiết kiệm",
	3: "Gói tiêu chuẩn",
	4: "Gói nâng cao",
}

const list_payment_method = [{
	'text': 'Tiền mặt',
	'value': 1,
}, {
	'text': 'Chuyển khoản ngân hàng',
	'value': 3,
}, {
	'text': 'Thanh toán POS',
	'value': 4,
}
]
const BANK_OPTION = [
	3, 4
]

const STATUS_ORDER = {
	"CANCEL": [0, -2],
	"APPOINTMENT": 1,
	"QUOTE": 2,
	"FIXING": 3,
	"FINISH": 4,
	"COMPLETED": 5,
	"IN_COMPLETE": [1, 2, 3, 4],
	"IS_EXPORT": [2, 3, 4],

}

const STATUS_SALE_ORDER = {
	DELETE: -1,
	CANCEL: 0,
	OPEN: 1,
	PACKED: 2,
	SHIPPING: 3,
	DONE: 4,
	RETURN: 5,
}

const WAREHOUSE_IMPORT = {
	STATUS: {
		CANCEL: 0,
		OPEN: 1,
		PACKED: 2,
		DONE: 3,
		RETURN: 4,
	}
}

export const ACTIVITY_LOG = {
	TYPE: {
		CREATE: 'create',
		UPDATE: 'update',
		DELETE: 'delete',
		CANCEL: 'cancel',
		PAY: 'pay',
	},
	BILL_TYPE: {
		CUSTOMER: 1,
		ORDER: 2,
		SCHEDULE: 3,
		CAR: 4,
		SALE: 5,
		RETURN_SALE: 6,
		PRODUCT: 7,
		SUPPLIER: 8,
		WAREHOUSE_IMPORT: 9,
		RETURN_IMPORT: 10,
		WAREHOUSE_CHECK: 11,
		WAREHOUSE_EXCHANGE: 12,
		RECEIPT_INCOME: 13,
		RECEIPT_OUTCOME: 14,
		BANK_INFO: 15,
		EXPORT: 16,

	}
}

export const list_status_order = [
	{
		'text': 'Xe trong xưởng',
		'value': "1, 2, 3, 4"
	}, {
		'text': 'Tiếp nhận',
		'value': 1,
	}, {
		'text': 'Báo giá',
		'value': 2,
	}, {
		'text': 'Đang sửa chữa',
		'value': 3,
	}, {
		'text': 'Hoàn thành',
		'value': 4,
	}, {
		'text': 'Xuất xưởng',
		'value': 5,
	}, {
		'text': 'Hủy',
		'value': "0, -2",
	}, {
		'text': 'Tất cả',
		'value': "-2, 0, 1, 2, 3, 4, 5"
	},
]

export const list_status_car = [
	 {
		'label': 'Chờ bán',
		'value': 1,
	}, {
		'label': 'Đã bán',
		'value': 2,
	}, {
		'label': 'Đã cọc',
		'value': 3,}
] 

export const list_object_type = [
	{
		'text': 'Đối tác',
		'value': 1,
	}, {
		'text': 'Nhân viên',
		'value': 2,
	},{
		'text': 'Khác',
		'value': 5,
	},
]

export const list_of_type = [
	{ key: "receipt-outcome", value: "Phiếu chi" },
	{ key: "order", value: "Phiếu tiếp nhận" },
	{ key: "sale-order", value: "Đơn hàng" },
	{ key: "return-order", value: "Trả hàng" },
	{ key: "receipt-income", value: "Phiếu thu" },
	{key: "car-sale", value: "Phiếu bán xe"},
	{ key: "car-import", value: "Nhập xe" },
	{ key: "car-sale-order", value: "Bán xe" },
	{ key: "car-service", value: "Phiếu chi phí" },
	{ key: "warehouse-import", value: "Phiếu nhập hàng" },
	{ key: "return-import", value: "Trả hàng" }
  ]
  export  const renderTypes = {
	"receipt-outcome": "Phiếu chi",
	"order": "Phiếu tiếp nhận",
	"sale-order": "Đơn hàng",
	"return-order": "Trả hàng",
	"receipt-income": "Phiếu thu",
	"car-import": "Nhập xe",
	"car-sale": "Bán xe",
	"car-sale-order": "Bán xe",
	"car-service": "Phiếu chi phí",
	"warehouse-import": "Phiếu nhập hàng",
	"return-import": "Trả hàng"
  };

export { list_unit, render_unit, list_plans, list_payment_method, TEXT_PLAN, LIST_UNIT, STATUS_ORDER, BANK_OPTION, WAREHOUSE_IMPORT, STATUS_SALE_ORDER }
